import Impression, { IImpressionProps } from '@/components/Common/Impression';
import { ILogFields } from '@/services/TrackerService/Kinesis/interfaces';
import React from 'react';

interface IImpressionDivWrapper<T> extends IImpressionProps<T> {
  className?: string;
}

/**
 * Impression 클라이언트 로그(Kinesis) 로그를 전송한다.
 *
 * 기본 동작은 Impression 컴포넌트와 동일함
 * chlidren 중 intersection-observer 가능하지 못한 경우 존재하여 div태그로 Wrapping한 컴포넌트
 * eg. chlidren가 React Component인데, forwardRef 처리가 불필요한 경우
 */
const ImpressionDivWrapper = <T extends Partial<ILogFields>>(props: IImpressionDivWrapper<T>): React.ReactElement => {
  return (
    <Impression {...props}>
      <div className={props.className}>{props.children}</div>
    </Impression>
  );
};

export default ImpressionDivWrapper;
